import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getCentreStatistics } from '@/store/statistics/actions'
import { Grid } from '@mui/material'

import dayjs from 'dayjs'
import Header from './components/Header'
import KpiList from './components/KpiList'
import PieChartCard from './components/PieChartCard'
import StatCard from './components/StatCard'
import DividerSection from '../DividerSection'
import LoaderCircle from '../LoaderCircle'
import {
  buildAgendasKpis,
  buildCashBoxModuleKpis,
  buildHCModuleKpis,
  buildModulesInUseKpis,
  buildPaymentMPModuleKpis,
  buildPrescriptionsModuleKpis,
  buildTurnsKpis,
  buildUsersKpis,
  buildWappModuleKpis,
} from './buildKpis'

import s from './styles.module.scss'

const Statistics = () => {
  const dispatch = useDispatch()
  const centreAdminDetail = useSelector((state) => state.centres.centreAdminDetail)
  const { statistics } = useSelector((state) => state.statistics)
  const [currentDate, setCurrentDate] = useState(dayjs())
  const [isLoading, setIsLoading] = useState(true)
  const agenda = buildAgendasKpis(statistics[0], centreAdminDetail?.centreConfiguration)
  const turns = buildTurnsKpis(statistics[0])
  const users = buildUsersKpis(statistics[0])
  const wappModule = buildWappModuleKpis(statistics[0])
  const hcModule = buildHCModuleKpis(statistics[0])
  const prescriptionsModule = buildPrescriptionsModuleKpis(statistics[0])
  const cashBoxModule = buildCashBoxModuleKpis(statistics[0])
  const paymentMPModule = buildPaymentMPModuleKpis(statistics[0])
  const modulesInUse = buildModulesInUseKpis(statistics[0])

  useEffect(() => {
    setInit()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentDate])

  const setInit = async () => {
    setIsLoading(true)
    const params = {
      centreId: centreAdminDetail._id,
      month: dayjs(currentDate).month() + 1,
      year: dayjs(currentDate).year(),
    }
    await dispatch(getCentreStatistics(params))
    setIsLoading(false)
  }

  return (
    <div className={s.container}>
      <Header centre={centreAdminDetail} currentDate={currentDate} setCurrentDate={setCurrentDate} />
      {isLoading ? (
        <LoaderCircle className={s.loader} />
      ) : (
        <>
          {statistics?.length ? (
            <Grid container className={s.statisticsContainer}>
              <Grid container spacing={2} className={s.statisticsContainer}>
                <Grid item xs={12} sm={6} md={6}>
                  <StatCard title={agenda?.title}>
                    <KpiList items={agenda?.items} />
                  </StatCard>
                </Grid>

                <Grid item xs={12} sm={6} md={6}>
                  <StatCard title={turns?.title}>
                    <PieChartCard data={turns?.items} />
                  </StatCard>
                </Grid>

                <Grid item xs={12} sm={6} md={6}>
                  <StatCard title={users?.title}>
                    <KpiList items={users?.items} />
                  </StatCard>
                </Grid>
              </Grid>
              <DividerSection label="USO POR MÓDULO" />
              <Grid container spacing={2} className={s.statisticsContainer}>
                <Grid item xs={12} sm={6} md={6}>
                  <StatCard title={wappModule?.title}>
                    <KpiList items={wappModule?.items} />
                  </StatCard>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <StatCard title={hcModule?.title}>
                    <KpiList items={hcModule?.items} />
                  </StatCard>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <StatCard title={prescriptionsModule?.title}>
                    <KpiList items={prescriptionsModule?.items} />
                  </StatCard>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <StatCard title={cashBoxModule?.title}>
                    <KpiList items={cashBoxModule?.items} />
                  </StatCard>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <StatCard title={paymentMPModule?.title}>
                    <KpiList items={paymentMPModule?.items} />
                  </StatCard>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <StatCard title={modulesInUse?.title}>
                    <KpiList items={modulesInUse?.items} />
                  </StatCard>
                </Grid>
              </Grid>
            </Grid>
          ) : (
            <div className={s.statisticsNoAvaiable}>No hay estadisticas disponibles para el mes seleccionado</div>
          )}
        </>
      )}
    </div>
  )
}

export default Statistics
